import type { ProductLogoSmallProps } from "../types";

export function ProductLogoSmallNetworks({
  size = 20,
  color = "#1874A1",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      {...props}
    >
      <path
        d="M349.923 290.608C355.663 293.922 357.629 301.261 354.315 307C351.002 312.74 343.663 314.706 337.923 311.392L317.138 299.392C311.399 296.079 309.432 288.74 312.746 283C316.06 277.261 323.399 275.294 329.138 278.608L349.923 290.608Z"
        fill="#1874A1"
      />
      <path
        d="M162.862 182.608C168.601 185.922 170.568 193.261 167.254 199C163.94 204.74 156.601 206.706 150.862 203.392L130.077 191.392C124.337 188.079 122.371 180.74 125.685 175C128.998 169.261 136.337 167.294 142.077 170.608L162.862 182.608Z"
        fill="#1874A1"
      />
      <path
        d="M386.081 359.981C371.732 351.697 366.816 333.349 375.1 319C383.384 304.651 401.732 299.735 416.081 308.019C430.43 316.304 435.346 334.651 427.062 349C418.777 363.349 400.43 368.265 386.081 359.981Z"
        fill="#1874A1"
      />
      <path
        d="M63.9193 173.981C49.5705 165.697 44.6543 147.349 52.9386 133C61.2228 118.651 79.5705 113.735 93.9193 122.019C108.268 130.304 113.184 148.651 104.9 163C96.6158 177.349 78.2681 182.265 63.9193 173.981Z"
        fill="#1874A1"
      />
      <path
        d="M252 361C252 367.627 246.627 373 240 373C233.373 373 228 367.627 228 361L228 337C228 330.373 233.373 325 240 325C246.627 325 252 330.373 252 337L252 361Z"
        fill="#1874A1"
      />
      <path
        d="M252 145C252 151.627 246.627 157 240 157C233.373 157 228 151.627 228 145V121C228 114.373 233.373 109 240 109C246.627 109 252 114.373 252 121V145Z"
        fill="#1874A1"
      />
      <path
        d="M210 427C210 410.431 223.431 397 240 397C256.569 397 270 410.431 270 427C270 443.569 256.569 457 240 457C223.431 457 210 443.569 210 427Z"
        fill="#1874A1"
      />
      <path
        d="M210 55C210 38.4315 223.431 25 240 25C256.569 25 270 38.4315 270 55C270 71.5685 256.569 85 240 85C223.431 85 210 71.5685 210 55Z"
        fill="#1874A1"
      />
      <path
        d="M337.922 170.607C343.662 167.293 351.001 169.26 354.314 174.999C357.628 180.739 355.662 188.078 349.922 191.391L329.138 203.391C323.398 206.705 316.059 204.739 312.745 198.999C309.431 193.26 311.398 185.921 317.138 182.607L337.922 170.607Z"
        fill="#1874A1"
      />
      <path
        d="M150.861 278.607C156.6 275.293 163.939 277.26 167.253 282.999C170.567 288.739 168.6 296.078 162.861 299.391L142.076 311.391C136.337 314.705 128.997 312.739 125.684 306.999C122.37 301.26 124.337 293.921 130.076 290.607L150.861 278.607Z"
        fill="#1874A1"
      />
      <path
        d="M416.08 173.98C401.731 182.264 383.383 177.348 375.099 162.999C366.815 148.65 371.731 130.303 386.08 122.018C400.429 113.734 418.776 118.65 427.061 132.999C435.345 147.348 430.429 165.696 416.08 173.98Z"
        fill="#1874A1"
      />
      <path
        d="M93.9183 359.98C79.5696 368.264 61.2218 363.348 52.9376 348.999C44.6533 334.65 49.5696 316.303 63.9183 308.018C78.2671 299.734 96.6148 304.65 104.899 318.999C113.183 333.348 108.267 351.696 93.9183 359.98Z"
        fill="#1874A1"
      />
      <path
        d="M180 241C180 207.863 206.863 181 240 181C273.137 181 300 207.863 300 241C300 274.137 273.137 301 240 301C206.863 301 180 274.137 180 241Z"
        fill="#1874A1"
      />
    </svg>
  );
}
